import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    tipoEjercicio: [],
  },

  getters: {
    getTipoEjercicio: (state) => state.tipoEjercicio,

    getListaEjercicio: (state) => {
      const listaEjercicios = [];

      state.tipoEjercicio.forEach((tipoEjercicio) => {
        listaEjercicios.push({
          ejercicioFisicoDeporte: 1,
          fk_idCatTipoEjercicio: tipoEjercicio.id,
          tipoEjercicio: tipoEjercicio.title,
          fk_idCatTiempo: null,
          fk_idCatFrecuencia: null,
        });
      });

      return listaEjercicios;
    },
  },

  mutations: {
    SET_TIPO_EJERCICIO(state, tipoEjercicio) {
      state.tipoEjercicio = tipoEjercicio;
    },
  },

  actions: {
    async fetchTipoEjercicio({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catTipoEjercicio')
        .then((response) => {
          commit('SET_TIPO_EJERCICIO', response.data.data);
        });
    },
  },
};
